import Header from "../components/Header"
import Checkbox from "../assets/CheckBox.svg"
import { Link } from "react-router-dom"
import Footer from "../components/Footer"
import Solutions from "../components/Solutions"
import Cases from "../components/Cases"
import Pricing from "../components/Pricing"
import MobileMenu from "../components/MobileMenu"
import MobileHeader from "../components/MobileHeader"
import useMenu from "../useMenu"


function LandingPage() {
  const {showMenu,CloseMenu, OpenMenu} = useMenu();
  
  return (
    <>
    <div className="landingpage ">
     <MobileMenu onClick={CloseMenu} className={showMenu ? "mobile-menu-container open-menu" : "mobile-menu-container"}/>
        <Header/>
        <MobileHeader  onClick={OpenMenu} className={showMenu ? " mobile-header menu-open" : "mobile-header"}/>
        <div className={showMenu ? "landing hero menu-open" : " landing-hero"}>
          <div className="landing-hero-left">
            <h2>The easiest way to accept payments online with <span>Personalized Links.</span></h2>
            <p>
            Payourl helps individuals and businesses to accept payments with personalized links from anyone anywhere in the world.
            </p>
            <div className="landing-hero-highlights">
              <div className="highlight-group">
                  <img src={Checkbox} alt="checkbox" />
                  <p>100% secure</p>
              </div>
              <div className="highlight-group">
                  <img src={Checkbox} alt="checkbox" />
                  <p>No hidden charges</p>
              </div>
              <div className="highlight-group">
                  <img src={Checkbox} alt="checkbox" />
                  <p>Free withdrawal</p>
              </div>
            </div>
            <Link className="header-signup-btn hero-btn" to='/signup'>Get Started</Link>
          </div>
          <div className="landing-hero-right"></div>
        </div>
        <div className="global-section">
          <div className="global-section-left">
            <h2>
            Basic and Seamless payment
            </h2>
            <p>
            Building a business can be extreme, we genuinely think getting compensated shouldn't be.
            </p>
            <div className="globe-group">
            <div className="globe"></div>
            </div>

          </div>
          <div className="global-section-right">
            <h2>
            Accept payments from anywhere in the world
            </h2>
            <p>
            Give your customers a chance to pay you with just a personalized URL. No coding knowledge required. Sign up now and start accepting payments.
            </p>
            <div className="highlight-group">
                  <img src={Checkbox} alt="checkbox" />
                  <p>Payment Page</p>
              </div>
          </div>
        </div>
        <Solutions />
        <Cases />
        <Pricing />
    </div>
<Footer />
</>
  )
}

export default LandingPage